import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';

// import Slider from './slider';

class TeamList extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        return (
            <>
                <div dangerouslySetInnerHTML={{ __html: content.teamList }} />
            </>
        );
    }
}

export default TeamList;
